export class IdentityDocumentTypeModel {
    id: number;
    type: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/identity-document-type-model.ts